import type { GamePageTranslations } from "@casino/server/graphql/getCmsGamePagePhrases";
import translatePhrase from "@casino/ui/Games/translatePhrase";

type Args = {
  isPending: boolean;
  translations?: GamePageTranslations;
};

const tournamentButtonLabel = ({ isPending, translations }: Args) => {
  if (isPending) {
    return translatePhrase(
      translations,
      "game.tournament.optinpending",
      "Opting in…",
    );
  }
  return translatePhrase(translations, "game.tournament.optin", "Opt in");
};

export default tournamentButtonLabel;
